function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';
const slideInAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(-100%);
  }

  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;
const slideOutAnimation = keyframes`
  from {
    opacity: 1;
    transform: translateY(0%);
  }

  to {
    opacity: 0;
    transform: translateY(-100%);
  }
`;
function SlideInOut({
  show,
  className,
  children
}) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  useEffect(() => {
    setMounted(true);
  }, [setMounted]);
  return /*#__PURE__*/jsx(SlideInOutContainer, {
    className: className,
    show: show,
    mounted: mounted,
    children: children
  });
}
const SlideInOutContainer = styled.div.withConfig({
  shouldForwardProp: p => !['show', 'mounted'].includes(p)
})`
  width: 100%;

  animation: ${slideInAnimation} ${({
  mounted
}) => mounted ? 200 : 0}ms
    ease-in;

  ${({
  show,
  mounted
}) => !show && css`
      animation: ${mounted ? 200 : 0}ms ${slideOutAnimation} forwards;
    `}
`;
export { SlideInOut, SlideInOutContainer };
//# sourceMappingURL=SlideInOutContainer.js.map
